export default __webpack_public_path__ + "static/media/market-report-default.2ed52318.jpg";